import { CustomEase } from 'gsap/CustomEase';

export const Eases = {
    ExpoInOut: 'expo.inOut',
    fastStart: CustomEase.create('fastStart', 'M0,0 C0,0 -0.035,0.58 0.235,0.852 0.457,1.074 1,1 1,1 '),
    exceed1: CustomEase.create('exceed1', 'M0,0 C0.126,0.382 0,0.79 0.477,1.077 0.727,1.227 0.909,1 1,1 '),
    wiggle1: CustomEase.create('wiggle1', 'M0,0 C0.056,0.171 0.069,0.599 0.191,0.715 0.34,0.857 0.396,0.6 0.515,0.617 0.715,0.642 0.65,0.979 0.769,1.059 0.888,1.138 0.954,1 1,1 '),
    wiggle2: CustomEase.create('wiggle2', 'M0,0 C0.126,0.382 0.11,1.048 0.327,1.062 0.619,1.08 0.535,0.661 0.713,0.67 0.951,0.681 0.909,1 1,1 '),

    genieY:  CustomEase.create('genieY', 'M0,0 C0.126,0.382 0.433,-0.1 0.6,-0.1 0.89,-0.1 0.909,1 1,1 '),

    slowStart: CustomEase.create('slowStart', 'M0,0 C0,0 0.534,-0.046 0.804,0.224 1.026,0.446 1,1 1,1 '),
    exceedInOut: CustomEase.create('exceedInOut', 'M0,0 C0.056,0.171 0.181,-0.124 0.349,-0.103 0.523,-0.08 0.442,0.93 0.711,1.072 0.846,1.143 0.954,1 1,1 '),
    exceedInSlowOut: CustomEase.create('exceedIn', 'M0,0 C0,0 0.189,1.197 0.571,1.21 0.697,1.213 0.739,0.95 0.803,0.916 0.922,0.854 1,1 1,1 '),
};
